// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 *
 * @export
 * @interface RiskAssociation
 */
export interface RiskAssociation {
  /**
   *
   * @type {string}
   * @memberof RiskAssociation
   */
  targetType: RiskAssociationTargetTypeEnum;
  /**
   * Internal id of the linked entity
   * @type {number}
   * @memberof RiskAssociation
   */
  targetId: number;
  /**
   * Human-readable number of the linked entity (e.g. TC-204)
   * @type {number}
   * @memberof RiskAssociation
   */
  targetDisplayNumber?: number;
  /**
   *
   * @type {string}
   * @memberof RiskAssociation
   */
  targetTitle?: string;
  /**
   * Role of the link (e.g. verifies, mitigates)
   * @type {string}
   * @memberof RiskAssociation
   */
  relationType?: string;
  /**
   *
   * @type {string}
   * @memberof RiskAssociation
   */
  createdAt?: string;
}

export function RiskAssociationFromJSON(json: any): RiskAssociation {
  return {
    targetType: json["target_type"],
    targetId: json["target_id"],
    targetDisplayNumber: !exists(json, "target_display_number")
      ? undefined
      : json["target_display_number"],
    targetTitle: !exists(json, "target_title")
      ? undefined
      : json["target_title"],
    relationType: !exists(json, "relation_type")
      ? undefined
      : json["relation_type"],
    createdAt: !exists(json, "created_at") ? undefined : json["created_at"],
  };
}

export function RiskAssociationToJSON(value?: RiskAssociation): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    target_type: value.targetType,
    target_id: value.targetId,
    target_display_number: value.targetDisplayNumber,
    target_title: value.targetTitle,
    relation_type: value.relationType,
    created_at: value.createdAt,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum RiskAssociationTargetTypeEnum {
  Requirement = "requirement",
  TestCase = "test_case",
  Defect = "defect",
}
